import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../Utils/api";

const ShiftControl = ({ userID }) => {
  const [status, setStatus] = useState("idle"); // "idle", "onShift", "onBreak"
  const [breakEnded, setBreakEnded] = useState(false); // Tracks if break has been used
  const [todayShift, setTodayShift] = useState(null);

  useEffect(() => {
    getUserTodayShift();
  }, []);

  useEffect(() => {
    if (todayShift) {
      if (!todayShift.clockIn) setStatus("idle");
      if (todayShift.clockIn && !todayShift.breakClockIn) setStatus("onShift");
      if (todayShift.breakClockIn && !todayShift.breakClockOut)
        setStatus("onBreak");
      if (todayShift.breakClockOut && !todayShift.clockOut)
        setStatus("onShift");
      if (todayShift.clockIn && todayShift.clockOut) setStatus("finished");
    }
  }, [todayShift]);

  const clockInOutShift = async (type) => {
    const res = await api.post("/schedule/clock_in_out", {
      scheduleID: todayShift._id,
      type: type,
    });

    if (res.data.success) {
      getUserTodayShift();
    } else {
      toast.error(res.data.message);
    }
  };

  const getUserTodayShift = async () => {
    const res = await api.post("/schedule/user_today", {
      userID: userID,
    });

    if (res.data.success) {
      setTodayShift(res.data.todayShift);
    }
  };

  const formatTime = (timeString) => {
    if (!timeString) return "-";
    const date = new Date(timeString);

    // Format the time using Intl.DateTimeFormat
    return new Intl.DateTimeFormat([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // use false for 24-hour format, true for AM/PM
      timeZone: "UTC", // optional: remove if you want local time
    }).format(date);
  };

  const renderStatusBadge = () => {
    switch (status) {
      case "onShift":
        return (
          <span className="bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-md">
            ON SHIFT
          </span>
        );
      case "onBreak":
        return (
          <span className="bg-yellow-500 text-white text-xs font-bold px-3 py-1 rounded-md">
            ON BREAK
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col items-center gap-2 px-4">
      {/* Status Badge */}
      {renderStatusBadge()}

      {/* Shift Info */}
      {todayShift && (
        <div className="text-center text-sm text-gray-900">
          <div>
            Shift started {formatTime(todayShift.clockIn)} [
            {todayShift.locationID.area}] at{" "}
            <span className="font-semibold">{todayShift.locationID.name}</span>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      {todayShift ? (
        <div className="flex gap-3 mt-2">
          {status === "idle" && (
            <button
              className="bg-green-50 text-green-600 text-sm font-semibold px-3 py-1.5 rounded-lg hover:bg-green-100 transition"
              onClick={() => {
                setStatus("onShift");
                clockInOutShift("clockIn");
                setBreakEnded(false); // reset break availability
              }}
            >
              Start Shift
            </button>
          )}

          {status === "onShift" && (
            <>
              {!breakEnded && (
                <button
                  className="bg-indigo-50 text-indigo-600 text-sm font-semibold px-3 py-1.5 rounded-lg hover:bg-indigo-100 transition"
                  onClick={() => {
                    clockInOutShift("breakClockIn");
                    setStatus("onBreak");
                  }}
                >
                  Start Break
                </button>
              )}
              <button
                className="bg-red-50 text-red-600 text-sm font-semibold px-3 py-1.5 rounded-lg hover:bg-red-100 transition"
                onClick={() => {
                  clockInOutShift("clockOut");
                  setStatus("idle");
                }}
              >
                End Shift
              </button>
            </>
          )}

          {status === "onBreak" && (
            <>
              <button
                className="bg-green-50 text-green-600 text-sm font-semibold px-3 py-1.5 rounded-lg hover:bg-green-100 transition"
                onClick={() => {
                  setStatus("onShift");
                  clockInOutShift("breakClockOut");
                  setBreakEnded(true); // prevent further breaks
                }}
              >
                End Break
              </button>
              <button
                className="bg-red-50 text-red-600 text-sm font-semibold px-3 py-1.5 rounded-lg hover:bg-red-100 transition"
                onClick={() => {
                  clockInOutShift("breakClockOut");
                  setStatus("idle");
                }}
              >
                End Shift
              </button>
            </>
          )}

          {status == "finished" && (
            <div className="bg-gray-600 text-white rounded-md px-2">
              Finished
            </div>
          )}
        </div>
      ) : (
        <div>No Shift</div>
      )}
    </div>
  );
};

export default ShiftControl;
